import { Component,OnInit, } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss']
})
export class KycComponent implements OnInit {
  panInfo:any;

  get isMainApplicant():boolean{
    return this.util.getCurrentApplicant.mainApplicant;
  };
  // panVerified:boolean=false;
  tickImage = 'assets/images/icons/tick_filled.svg'
  get moratorium():boolean{
    return this.loanDetails && (this.loanDetails.hasMoratorium || this.loanDetails.isCapacitaFlow)  && this.loanDetails.isStudentMainApplicant && this.currentApplicant.mainApplicant;
  }
  constructor(public util:UtilService){}
  get loanDetails(){
    return this.util.loanDetails;
  }
  get panVerified(){
      return this.util.getCurrentApplicant.panConfirmation;
  }
  get employmentVerified(){
    return this.util.getCurrentApplicant.empInfo != null;
}
get bankVerified(){
  const loan = this.loanDetails;
  if(!loan){
    return false;
  }
  if(loan.loanApplicantDetails.length>1){
    return loan.loanApplicantDetails[1].bankConfirmation;
  }
  return this.util.getCurrentApplicant.bankConfirmation;
}
get kycVerified(){
  return this.util.getCurrentApplicant.aadhaarConfirmation && !this.currentApplicant.selfiNotComplete ;
}
get currentApplicant() {
  return this.loanDetails && this.loanDetails.loanApplicantDetails.find((app:any) => app.id === this.util.getCurrentApplicant.id);
}
  get steps(){
    // const loanDetail = this.util.getCurrentApplicant;
    // return (Number(loanDetail.panConfirmation  ) + (Number(loanDetail.empInfo != null )) + Number(loanDetail.bankConfirmation ) + Number(loanDetail.aadhaarConfirmation ));
    switch(true){
      case this.kycTab =='basic':
        return 1;
      case this.kycTab == 'employment':
        return 2;
      case this.kycTab == 'bank':
        return 3;
      case this.kycTab =='KYC':
        return this.moratorium ? 2 :4;
      default: 
        return 0;
    }
  }


  get  kycTab(){
    return this.util.getCache('kycTab');
  }

  ngOnInit(): void {
  
 
  }

  gotoHome(){
    this.util.route('home');
  }
  
  // panTab(){
  //   if(this.kycTab =='employment' ){
  //     return;
  //   }
  //   if(this.util.getCache('panNumber') || this.panInfo){
  //     this.util.setCache('kycTab' , 'pan');
  //     this.util.route('pan');
  //   }
  // }

  // basicTab(){
  //   if(this.kycTab =='employment' ){
  //     return;
  //   }
  //   if(this.util.getCache('panNumber') || this.panInfo){
  //     this.util.setCache('kycTab' , 'basic');
  //     this.util.route('basicDetails');
  //   }
  // }
 
}
